// src/components/ConfirmEmail.js
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import supabase from '../supabaseClient';
import LoadingModal from './LoadingModal';
import Logo from '../images/HouvalDark.png'; // Adjust path as needed
import loginBG from '../images/loginBG.jpg'; // Import the background image

const ConfirmEmail = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    const checkSession = async () => {
      try {
        const { data: { session } } = await supabase.auth.getSession();
        if (session) {
          setMessage('Your email has been confirmed successfully.');
        } else {
          setError('Unable to confirm email. Please try logging in.');
        }
      } catch (err) {
        setError('An unexpected error occurred.');
        console.error('Email Confirmation Error:', err);
      }
      setIsLoading(false);
    };

    checkSession();
  }, []);

  const handleNavigate = () => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      if (session) {
        navigate('/portal');
      } else {
        navigate('/');
      }
    });
  };

  return (
    <>
      <div
        className="min-h-screen flex items-center justify-center text-white relative"
        style={{
          backgroundImage: `url(${loginBG})`, // Use the imported image
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      >
        {/* Loading Modal */}
        <LoadingModal loadingModalVisible={isLoading} />

        {/* Overlay */}
        <div className="absolute top-0 left-0 right-0 bottom-0 bg-black bg-opacity-60 z-0"></div>

        {/* Confirmation Message Container */}
        <div className="relative z-10 bg-gray-50 p-8 rounded-md shadow-lg w-full max-w-md text-center">
          {/* Logo */}
          <div className="mb-6">
            <img src={Logo} alt="Logo" width="150" />
          </div>

          {/* Confirmation or Error Message */}
          {!isLoading && (
            <div>
              {error ? (
                <p className="text-red-500 text-sm mb-4">{error}</p>
              ) : (
                <>
                  <p className="text-green-500 text-sm mb-4">{message}</p>
                  <button
                    className="bg-yellow-400 text-black font-bold py-2 px-4 rounded focus:outline-none focus:ring focus:border-yellow-300 transition duration-200"
                    onClick={handleNavigate}
                  >
                    Go to Portal
                  </button>
                </>
              )}
            </div>
          )}
        </div>
      </div>

      {/* Responsive Styles */}
      <style jsx>{`
        @media (min-width: 769px) {
          .relative.z-10 {
            width: 400px; /* Fixed width for non-mobile devices */
          }
        }
        @media (max-width: 768px) {
          .relative.z-10 {
            width: 100%; /* Ensure full width on mobile devices */
          }
        }
      `}</style>
    </>
  );
};

export default ConfirmEmail;
